import React, { useState } from 'react';
import i18next from "i18next";

import EAIcon from "components/common/EAIcon";
import EADialog from "components/common/EADialog";
import useStyles from "style/js-style/containers/administration/roles/dialogsStyle";
import { Checkbox, FormControlLabel } from '@mui/material';


const RoleSaveDialog = ({
  isOpen,
  onClose = () => { },
  handleSave
}) => {
  const { classes } = useStyles();
  const [shouldInheritBaseRolePrivileges, setShouldInheritBaseRolePrivileges] = useState(true);

  const onChange = (e) => {
    setShouldInheritBaseRolePrivileges(e.target.checked);
  }

  return (
    <EADialog
      isOpen={isOpen}
      fullWidth
      maxWidth="popupxs"
      customBtnStyle={{ paddingBottom: '24px !important' }}
      customDialogStyle={{ paddingBottom: '0 !important' }}
      onCancel={() => onClose()}
      onValidate={() => handleSave(shouldInheritBaseRolePrivileges)}
    >
      <div className={classes.root}>
        <EAIcon icon="roles/popup-add-role" />
        <h2 className={classes.title}>
          {i18next.t('roles.popup.editingParent')}
        </h2>

        <div className={classes.mainContentWrapper}>
          <p style={{ color: '#535362', fontSize: '16px', margin: 0 }}>
            {i18next.t('roles.popup.propagateChange')}
          </p>

          <div>
            <FormControlLabel
              label={i18next.t('roles.popup.propagatePrivileges')}
              control={
                <Checkbox checked={shouldInheritBaseRolePrivileges} onChange={onChange} />
              }
              sx={{
                '& .MuiTypography-root': {
                  fontSize: '14px !important',
                  color: '#7E7E8F',
                  fontWeight: '600',
                  marginRight: '0',
                },
                position: 'relative',
                top: '10px',
                marginRight: '0',
                width: 'calc(100% + 50px)',
              }}
            />
          </div>
          <p style={{ color: '#FF9A00', fontSize: '14px', fontWeight: '500', position: "relative", top: "-5px" }}>
            {i18next.t('roles.popup.warningPropagate')}
          </p>
        </div>
      </div>
    </EADialog>
  );
};

export default RoleSaveDialog;
